<h2 mat-dialog-title class="font-semibold text-xl">
  <ng-container [ngSwitch]="data.mode">
    <span *ngSwitchCase="'report'">Report Payment Issue</span>
    <span *ngSwitchCase="'submitted'">Payment Issue Submitted</span>
    <span *ngSwitchCase="'resolved'">Payment Issue Resolved</span>
  </ng-container>
</h2>
<mat-dialog-content class="space-y-3">
  <div>
    <div class="text-sm text-gray-700">
      <span *ngIf="data.context === 'load'">Load ID:</span>
      <span *ngIf="data.context === 'settlement'">Settlement ID:</span>
      <a class="text-blue-600 underline cursor-pointer" (click)="goToLink()">{{ data.link.text }}</a>
    </div>
  </div>

  <ng-container [ngSwitch]="data.mode">
    <div *ngSwitchCase="'report'" class="space-y-2">
      <div class="text-sm">Please select the type(s) of issue you are experiencing with this payment.</div>
      <div class="space-y-2" *ngIf="issueTypes$ | async as issueTypes">
        <div *ngFor="let issueType of issueTypes; trackBy: trackByIssueTypeId" class="flex items-center">
          <mat-checkbox [checked]="isIssueTypeSelected(issueType.id)" (change)="toggleIssueType(issueType.id)">
            {{ issueType.displayName }}
          </mat-checkbox>
        </div>
        <div *ngIf="selectedIssueTypeIds.size === 0" class="text-xs text-red-600">
          Please select at least one issue type
        </div>
      </div>
      <div class="text-xs text-gray-600">We will have a resolution to your issue within 48 hours.</div>
    </div>

    <div *ngSwitchCase="'submitted'" class="space-y-2">
      <ng-container *ngIf="issueTypes$ | async as issueTypes">
        <div class="font-semibold">{{ data.paymentIssue?.issue ? 'Issue:' : 'Issues:' }}</div>
        <div *ngIf="data.paymentIssue?.issue" class="whitespace-pre-wrap">{{ data.paymentIssue?.issue }}</div>
        <ul *ngIf="hasIssueTypes()" class="list-disc list-inside">
          <li *ngFor="let displayName of getIssueTypeDisplayNames(issueTypes); trackBy: trackByIndex">
            {{ displayName }}
          </li>
        </ul>
      </ng-container>
      <div class="font-semibold pt-2">Resolution:</div>
      <div>
        Will be resolved by
        <span class="font-semibold">{{ getTargetResolveDate() | date: 'MMM d, y, h:mm a':'America/Denver' }}</span>
        Mountain Time
      </div>
    </div>

    <div *ngSwitchCase="'resolved'" class="space-y-2">
      <ng-container *ngIf="issueTypes$ | async as issueTypes">
        <div class="font-semibold">{{ data.paymentIssue?.issue ? 'Issue:' : 'Issues:' }}</div>
        <div *ngIf="data.paymentIssue?.issue" class="whitespace-pre-wrap">{{ data.paymentIssue?.issue }}</div>
        <ul *ngIf="hasIssueTypes()" class="list-disc list-inside">
          <li *ngFor="let displayName of getIssueTypeDisplayNames(issueTypes); trackBy: trackByIndex">
            {{ displayName }}
          </li>
        </ul>
      </ng-container>
      <div class="font-semibold pt-2">Resolution:</div>
      <div class="whitespace-pre-wrap">
        {{
          data.paymentIssue?.response ||
            data.paymentIssue?.responseText ||
            data.paymentIssue?.resolution ||
            'This issue has been resolved.'
        }}
      </div>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close *ngIf="data.mode !== 'report'">OK</button>
  <ng-container *ngIf="data.mode === 'report'">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="submit()">Submit Issue</button>
  </ng-container>
</mat-dialog-actions>
